<template>
  <div class="text-container" style="color: #333">
    <div class='hd hd1'>瑞为客平台隐私政策</div>
      <div class='bd'>您的个人信息安全对我们来说至关重要。一直以来，瑞为客都致力于为每位用户提供更安全的互联网环境。我们将依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》（GB/T 35273-2017）以及其他相关法律法规和技术规范收集和使用您的个人信息，以帮助我们向您提供更优质的瑞为客产品和/或服务。《瑞为客平台隐私政策》（以下简称“本政策”）是对旧版的升级与修订，以更透明地呈现我们收集和使用您个人信息的情况，以及您享有的对个人信息的控制权。我们承诺会对您的个人信息和其它数据进行严格保密，并严格按照本政策所阐述的内容处理您的个人信息。我们会根据您的同意和其它可处理您个人信息的法律依据收集、使用、存储、共享和转移您的个人信息。</div>
      <div class='hd'><text>以下是《瑞为客平台隐私政策》的要点说明：</text></div>
      <div class='bd'><text>1. 为帮助您注册并使用瑞为客产品或服务，我们可能收集与提供服务相关的个人信息，您有权拒绝或撤回授权；</text></div>
      <div class='bd'><text>2. 您可以访问、更正、删除您的个人信息，改变您授权同意的范围，注销您的帐号，我们为您提供了行使这些权利的途径。</text></div>
      <div class='bd'><text>3. 我们采取了互联网业内标准的技术措施和数据安全措施来保护您的个人信息安全。</text></div>
      <div class='bd'><text>4. 除非再次征得您的同意，我们不会将您的个人信息用于本政策未载明的其他目的。</text></div>
      <div class='bd'><text>5. 当您对本政策有任何疑问，可以和我们进一步联系与咨询。</text></div>
      <div class='bd'><text>6. 请确认您为 18 岁以上人士。</text></div>
      <div class='bd'><text>为了更好保护您的个人信息，建议您完整阅读《瑞为客平台隐私政策》。</text></div>
      <div class='hd'><text>目录</text></div>
      <div class='hd'>1. 引言；</div>
      <div class='hd'>2. 我们处理个人信息的法律依据；</div>
      <div class='hd'>3. 我们如何收集和使用您的个人信息；</div>
      <div class='hd'>4. 我们如何共享、转让、公开披露您的个人信息；</div>
      <div class='hd'>5. 我们如何保护您的个人信息；</div>
      <div class='hd'>6. 您管理个人信息的权利；</div>
      <div class='hd'>7. 我们发出的通知；</div>
      <div class='hd'>8. 对个人信息的存储；</div>
      <div class='hd'>9. 我们如何使用 Cookie 和其他追踪技术；</div>
      <div class='hd'>10. 我们如何处理未成年人的个人信息；</div>
      <div class='hd'>11. 如何更新本政策；</div>
      <div class='hd'>12. 如何联系我们；</div>
      <div class='hd'>13. 争议解决；</div>
      <div class='hd'>14. 名词解释。</div>
      <div class='hd'><text>1. 引言</text></div>
      <div class='bd'>本政策中，“瑞为客”是指包括瑞为客平台的开发者和运营者即厦门瑞为信息技术有限公司（以下简称「我们」）。</div>
      <div class='bd'>本政策中，“瑞为客平台”是指厦门瑞为信息技术有限公司开发和运营的“瑞为客”，“瑞为客管家”以及其他附加和衍生产品，以sass服务为主的网页及客户端（包括App、微信小程序或H5页面）。</div>
      <div class='hd'><text>【特别提示】</text></div>
      <div class='bd'><text>请您在使用我们的各项产品和/或服务前，仔细阅读并充分理解本政策。重点内容我们已采用粗体表示，希望您特别关注。一旦您使用或继续使用瑞为客产品/服务，即表示您同意我们按照本政策处理您的相关信息。如对本政策有任何疑问，您可以通过政策中「如何联系我们」一节提供的联系方式/客服系统与我们联系。</text></div>
      <div class='bd'><text>为了便于您理解本政策中的相关概念，我们对专有名词标记了下划线并在本政策第 14 节「名词解释」中给予详细介绍。本政策中相关名词的右上角用“*”标记的，代表涉及瑞为客收集的敏感信息，我们向您加以增强式提示。</text></div>
      <div class='bd'><text>我们可能会不时对《瑞为客平台隐私政策》进行修订。当《瑞为客平台隐私政策》发生变更时，我们会在版本更新后以推送通知、弹窗等形式向您展示变更后的内容。</text></div>
      <div class='bd'><text>请您注意，只有在您确认同意变更后，我们才会按照更新后的《瑞为客平台隐私政策》收集、使用、处理和存储您的个人信息；您可以选择不同意，我们可能将导致您无法完整使用瑞为客的服务和功能。</text></div>
      <div class='hd'><text>2. 瑞为客处理个人信息的法律依据</text></div>
      <div class='bd'>如果您是中华人民共和国大陆地区的用户，我们将依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》（GB/T 35273-2017）以及其他相关法律法规收集和使用您的个人信息，为您提供瑞为客产品和/或服务。<text>我们通常只会在征得您同意的情况下收集您的个人信息。</text> 在某些情况下，我们可能还会基于法律义务或者履行合同之必需向您收集个人信息，或者可能需要个人信息来保护您的重要利益或其他人的利益。</div>
      <div class='hd'><text>3. 我们如何收集和使用您的个人信息</text></div>
      <div class='bd'><text>我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用服务过程中主动提供或因使用瑞为客产品和/或服务而产生的个人信息。如果我们要将您的个人信息用于本政策未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</text></div>
      <div class='hd'><text>3.1 帮助您成为我们的在线用户</text></div>
      <div class='bd'><text>注册帐号：</text></div>
      <div class='bd'>1. 您注册并登录瑞为客帐号时， <text>需要向我们提供以下信息：帐号名称、头像（如有）和手机号码（用于实名认证）。提供上述信息并同意《瑞为客服务协议》和本政策后，您可以使用瑞为客的核心业务功能，包括：浏览瑞为客平台内的内容，预订房源，办理入住，开锁服务等。</text> 如果您选择不提供为实现瑞为客核心业务功能的必备信息或使用其中某类功能的必备信息，将导致我们无法为您提供该功能。</div>
      <div class='hd'><text>3.2 向您提供产品和/或服务</text></div>
      <div class='bd'><text>A. 向您提供瑞为客产品和/或服务的核心业务功能</text></div>
      <div class='bd'>为实现瑞为客的核心业务功能，我们可能需要向您收集个人信息。以下将详细列出瑞为客的核心业务功能及为实现该功能所需收集的个人信息，若您拒绝收集，则无法使用该服务。</div>
      <div class='bd'>1. <text>浏览功能。</text>您可浏览的内容包括房源信息、订单信息、相关活动信息。为兼容各种移动设备，以便提供正常的服务， <text>我们可能会收集您使用瑞为客时的设备信息，如设备型号、唯一设备标识符、操作系统、分辨率、电信运营商等软硬件信息。</text></div>
      <div class='bd'>2. <text>发布功能。</text>您注册成为“瑞为客管家”用户后可以根据提示发布相应的房源信息和新增订单。在此过程中， <text>我们可能会收集您的设备信息、浏览器类型、日志信息，文件信息。</text></div>
      <div class='bd'><text>B．向您提供瑞为客产品和/或服务的附加业务功能</text></div>
      <div class='bd'>为了向您提供更优质的产品和服务，我们可能需要收集下述信息。 <text>如果您拒绝提供下述信息，不影响您正常使用 3.2 A 项所描述的瑞为客核心业务功能，但我们无法向您提供某些特定功能和服务。</text></div>
      <div class='bd'>1. <text>定位功能。</text>当您开启设备定位功能并使用瑞为客基于位置提供的相关服务时（比如定位房源位置信息）， <text>我们会收集有关您的位置信息。</text></div>
      <div class='bd'>2. <text>搜索功能。</text>当您使用瑞为客提供的搜索功能时，我们会收集您查询的关键字信息以及您在使用瑞为客服务时所阅览或要求的其他信息和内容详情。为了给您带来更便捷的搜索服务并不断完善瑞为客产品和/或服务，我们可能会使用应用数据缓存，收集您设备上的信息并进行本地存储。 <text>该等关键词信息通常无法单独识别您的个人身份，不属于您的个人信息，不在本政策的限制范围内。只有当您的搜索关键词信息与您的其他信息有联结并可识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本政策对其进行处理与保护。</text></div>
      <div class='bd'>3. <text>身份认证服务。 </text>瑞为客提供身份认证服务，在对您个人信息的真实性进行审核后，会为您标记认证标识。 <text>因此，当您申请瑞为客为您进行身份认证时，我们需要收集您的姓名、证件号码、有关身份证明*的信息，以证实您的个人身份。</text></div>
      <div class='bd'>4. <text>客户服务。 </text>当您向瑞为客提起投诉、申诉或进行咨询时，为了方便与您联系或帮助您解决问题， <text>我们可能需要您提供姓名、手机号码、电子邮件及其他联系方式等个人信息。</text> 如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。</div>
      <div class='bd'>5. <text>定向推送。</text>我们会基于订单状态，向您推送订单信息，验证信息等。为此， <text>我们需要收集的信息包括您的设备信息，启用短信服务。</text></div>
      <div class='bd'>6. <text>蓝牙服务。</text>您可在入住预订房源并使用开锁功能时。在您使用该功能的过程中可能会需要蓝牙功能，在开锁过程中， <text>我们可能会收集您的蓝牙信息用于匹配房源门锁，以完成开锁服务。</text></div>
      <div class='hd'><text>3.3 我们可能从第三方间接获取您的个人信息</text></div>
      <div class='bd'><text>A. 您使用第三方帐号（微信）登录瑞为客时，可选择授权瑞为客在符合相关法律法规要求的前提下读取并获得您在该第三方平台上登记、公布、记录的公开信息（包括昵称、头像）。</text></div>
      <div class='bd'><text>B. 瑞为客需要您授权从第三方获取上述信息是为了记住您作为瑞为客用户的登录身份，以向您提供更优质的产品和/或服务。我们仅会在您的授权同意的范围内收集并使用您的个人信息。</text>在您使用第三方帐号注册或登录后，您的第三方帐号将会与瑞为客帐号进行绑定。</div>
      <div class='hd'><text>3.4 敏感信息</text></div>
      <div class='bd'>在向瑞为客提供任何属于敏感信息的个人信息前，请您清楚考虑该等提供是恰当的并且同意您的个人敏感信息可按本政策所述的目的和方式进行处理。</div>
      <div class='bd'>我们会在得到您的同意后收集和使用您的敏感信息以实现与瑞为客业务相关的功能，并允许您对这些敏感信息的收集与使用做出不同意的选择，但是拒绝使用这些信息会影响您使用相关功能。</div>
      <div class='hd'><text>3.5 征得授权同意的例外</text></div>
      <div class='bd'>根据相关法律法规的规定， <text>在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息：</text></div>
      <div class='bd'>a. 与国家安全、国防安全直接相关的；</div>
      <div class='bd'>b. 与公共安全、公共卫生、重大公共利益直接相关的；</div>
      <div class='bd'>c. 与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
      <div class='bd'>d. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
      <div class='bd'>e. 所收集的个人信息是您自行向社会公众公开的；</div>
      <div class='bd'>f. 从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；</div>
      <div class='bd'>g. 根据您的要求签订和履行合同所必需的；</div>
      <div class='bd'>h. 用于维护瑞为客的产品和/或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</div>
      <div class='bd'>i. 法律法规规定的其他情形。</div>
      <div class='hd'><text>3.6 如果您对我们收集和使用您的个人信息的法律依据有任何疑问或需要提供进一步的信息，请通过「如何联系我们」一节提供的联系方式与我们联系。</text></div>
      <div class='hd'><text>4. 我们如何共享、转让、公开披露您的个人信息</text></div>
      <div class='hd'><text>4.1 共享您的个人信息</text></div>
      <div class='bd'>A. 我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</div>
      <div class='bd'><text>1.事先获得您的明确授权或同意：</text>获得您的明确同意后，我们会与其他方共享您的个人信息；</div>
      <div class='bd'><text>2. 在法定情形下的共享：</text>根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；</div>
      <div class='bd'><text>3. 在法律要求或允许的范围内，为了保护瑞为客及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；</text></div>
      <div class='bd'><text>4. 与我们的关联公司共享：</text>您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，且这种共享受本政策所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；</div>
      <div class='bd'><text>B.有关共享信息的提示：通过由我们或第三方提供的功能，您可以主动公开分享、共享信息（如向其他互联网平台转发内容），在这种情况下共享信息将被广泛并即时传送。</text></div>
      <div class='bd'><text>但只要您不删除被共享的信息，该信息会一直留存在公众领域；在一些情况下，即使您删除共享信息，该等信息仍可由其他用户或与我们没有关联及不受我们控制的第三方独立地缓存、复制或储存，或通过其他用户或该等第三方在公众领域保存。</text></div>
      <div class='hd'><text>4.2. 转让</text></div>
      <div class='bd'><text>除非获取您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。</text></div>
      <div class='bd'>如果发生合并、收购或破产清算，将可能涉及到个人信息转让，此种情况下我们会要求新的持有您个人信息的公司、组织继续受本政策的约束。如果本政策中约定的个人信息的收集、处理方式发生任何改变，该公司、组织将重新向您征求授权同意。</div>
      <div class='hd'><text>4.3. 公开披露</text></div>
      <div class='bd'><text>除非获取您的明确同意，我们不会公开披露您的个人信息。</text></div>
      <div class='bd'>基于法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会向有权机关披露您的个人信息。但我们保证，在上述情况发生时，我们会要求披露请求方必须出具与之相应的有效法律文件，并对被披露的信息采取符合法律和业界标准的安全防护措施。</div>
      <div class='hd'><text>4.4. 共享、转让、公开披露个人信息授权同意的例外</text></div>
      <div class='bd'>根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下共享、转让、公开披露您的个人信息：</div>
      <div class='bd'>A. 与国家安全、国防安全有关的；</div>
      <div class='bd'>B. 与公共安全、公共卫生、重大公共利益有关的；</div>
      <div class='bd'>C. 与犯罪侦查、起诉、审判和判决执行等有关的；</div>
      <div class='bd'>D. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
      <div class='bd'>E. 您自行向社会公众公开的个人信息；</div>
      <div class='bd'>F. 从合法公开披露的信息中收集到的个人信息的，如合法的新闻报道、政府信息公开等渠道。</div>
      <div class='bd'>G. 法律法规规定的其他情形。</div>
      <div class='bd'>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</div>
      <div class='hd'><text>5. 我们如何保护您的个人信息</text></div>
      <div class='bd'>您的个人信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的措施，保护您的个人信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。</div>
      <div class='hd'><text>5.1 技术措施与数据安全措施</text></div>
      <div class='bd'>我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息安全。我们积极建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用，确保未收集与我们提供的服务无关的个人信息。</div>
      <div class='bd'>我们通过与信息接触者签署保密协议、监控和审计机制来对数据进行全面安全控制。防止您的个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。</div>
      <div class='bd'>我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改，防止数据发生损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可以访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</div>
      <div class='hd'><text>5.2 安全事件处置</text></div>
      <div class='bd'>我们将尽力确保您发送给我们的任何信息的安全性，但请您理解，由于技术的限制以及在互联网行业可能存在的各种恶意手段，不可能始终保证信息百分之百的安全。您需要了解，您接入我们服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。为防止安全事故的发生，我们制定了妥善的预警机制和应急预案。若不幸发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和对您的补救措施，并立即启动应急预案，力求将损失最小化。我们将及时将事件相关情况以电话、推送通知等方式告知您，难以逐一告知用户时，我们会采取合理、有效的方式发布公告。</div>
      <div class='bd'>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况，紧密配合政府机关的工作。</div>
      <div class='hd'><text>6. 您管理个人信息的权利</text></div>
      <div class='bd'><text>我们非常重视您对个人信息的关注，并尽全力保护您对于自己个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。</text>您的权利包括：</div>
      <div class='hd'><text>6.1 访问和更正您的个人信息</text></div>
      <div class='bd'>A. 除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：</div>
      <div class='bd'>1. “瑞为客管家”电脑端：登录“瑞为客管家”，点击“个人中心”；</div>
      <div class='bd'>2. “瑞为客管家”微信小程序：登录“瑞为客管家”小程序，点击“我的”；</div>
      <div class='bd'>3. “瑞为客”微信小程序：登录“瑞为客”小程序，点击“我的”；</div>
      <div class='bd'>B. 如果您需要查阅您在使用瑞为客过程中产生的其他个人信息，在合理要求下，我们会向您提供。</div>
      <div class='bd'>C. 在以下情形中，您可以向我们提出删除个人信息的请求：</div>
      <div class='bd'>1. 如果我们处理个人信息的行为违反法律法规；</div>
      <div class='bd'>2. 如果我们收集、使用您的个人信息，却未征得您的同意；</div>
      <div class='bd'>3. 如果我们处理个人信息的行为违反了与您的约定；</div>
      <div class='bd'>4. 如果您注销了瑞为客帐号；</div>
      <div class='bd'>5. 如果我们终止服务及运营。</div>
      <div class='hd'><text>6.2 设备权限调用</text></div>
      <div class='bd'><text>我们在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机、手机通讯录、蓝牙、定位等访问权限。</text></div>
      <div class='hd'><text>7. 我们发出的通知</text></div>
      <div class='hd'><text>7.1. 通知及其他类别的通讯</text></div>
      <div class='bd'>当您使用瑞为客服务时，我们可利用您的个人信息向您的设备发出推送通知。</div>
      <div class='hd'><text>7.2. 与服务有关的公告</text></div>
      <div class='bd'>我们可在我们认为必需时（例如当我们暂停瑞为客服务进行维修时）不时向您发出一些与服务有关的公告。您不可取消这些与服务有关、性质不属于推广的公告。</div>
      <div class='hd'><text>8. 您个人信息的存储</text></div>
      <div class='bd'><text>我们将从中华人民共和国境内获得的信息存放于中华人民共和国境内。</text>如果发生数据的跨境传输，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。</div>
      <div class='bd'><text>我们承诺您个人信息的存储时间始终处于合理必要期限内。</text>在仅浏览功能下所收集的个人信息，我们的存储期限不会超过一个月(例如用户的缓存cookie)。对于超出期限的个人信息，我们会立即删除或做匿名化处理。</div>
      <div class='bd'><text>如我们因经营不善或其他原因出现停止运营的情况，我们会立即停止对您个人信息的收集，删除已收集的个人信息。</text>我们会将此情况在网站上进行公告或以站内信、邮件等其他合理方式逐一传达到各个用户。</div>
      <div class='hd'><text>9. 我们如何使用 Cookie 和其他追踪技术</text></div>
      <div class='bd'>您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用 Cookie 功能后，可能影响您访问瑞为客或不能充分取得瑞为客提供的服务。</div>
      <div class='bd'>我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。</div>
      <div class='hd'><text>10. 我们如何处理未成年人的个人信息</text></div>
      <div class='hd'><text>10.1 瑞为客服务主要面向成人。我们的产品、网站和服务主要面向成人。若您是 18 周岁以下的未成年人，在使用我们的产品和/或服务前，您应在监护人的陪同下阅读本政策，并应确保已征得您的监护人同意后使用我们的服务并向我们提供您的信息。 </text>我们会根据国家相关法律法规的规定着重保护未成年人的个人信息。</div>
      <div class='hd'>10.2 如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们。</div>
      <div class='hd'>10.3 对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</div>
      <div class='hd'>10.4 若您是未成年人的监护人，当您对您所监护的未成年人使用我们的服务或其向我们提供的用户信息有任何疑问时，请您及时与我们联系。我们将根据国家相关法律法规及本政策的规定保护未成年人用户信息的保密性及安全性。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</div>
      <div class='hd'><text>11. 如何更新与修改本政策</text></div>
      <div class='hd'><text>11.1 本政策为《瑞为客服务协议》的重要组成部分。瑞为客保留不时更新或修改本政策的权利。</text></div>
      <div class='hd'><text>11.2 未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会通过 App 客户端推送通知、弹窗形式等合理方式通知您，以便您能及时了解本政策所做的任何变更。</text></div>
      <div class='hd'>11.3 对于重大变更，视具体情况我们 <text>可能还会提供更为显著的通知</text>说明本政策的具体变更内容。 <text>重大变更包括但不限于：</text></div>
      <div class='bd'>A. 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div>
      <div class='bd'>B. 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</div>
      <div class='bd'>C. 个人信息共享、转让或公开披露的主要对象发生变化；</div>
      <div class='bd'>D. 您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
      <div class='bd'>E. 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</div>
      <div class='bd'>F. 个人信息安全影响评估报告表明存在高风险时。</div>
      <div class='hd'>11.4 若您不同意修改后的隐私政策，您有权并应立即停止使用瑞为客的服务。如果您继续使用瑞为客的服务，则视为您接受瑞为客对本政策相关条款所做的修改。</div>
      <div class='hd'><text>12. 如何联系我们</text></div>
      <div class='bd'>当您对本政策有任何疑问，可以通过拨打0592-5939517联系我们，我们将及时解决您的问题。</div>
      <div class='hd'><text>13. 争议解决</text></div>
      <div class='hd'><text>如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向厦门市思明区人民法院提起诉讼解决。</text></div>
      <div class='hd'><text>14. 名词解释</text></div>
      <div class='bd'>本隐私政策中使用到的名词，在通常意义中有如下定义：</div>
      <div class='bd'><text>1. 个人信息：</text>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等。</div>
      <div class='bd'><text>2. 个人敏感信息：</text>个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等。</div>
      <div class='bd'><text>3. 设备： </text>设备是指可用于访问瑞为客产品和/或服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。</div>
      <div class='bd'><text>4. 唯一设备标识符： </text>唯一设备标识符（专属 ID 或 UUID）是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（例如手机的 IMEI 号）。唯一设备标识符有多种用途，其中可在不能使用 Cookie（例如在移动应用程序中）时用以提供广告。</div>
      <div class='bd'><text>5. 信息收集技术：</text>我们在《瑞为客平台隐私政策》中所述的“自动收集”包括以下方式：</div>
      <div class='bd'><text> A. Cookie（曲奇档案） </text>Cookie 是您浏览网页时，网站服务器放在客户端（您的计算机、移动电话或其他智能终端内）里面的一个小小的文本文件，当您再次访问相应网站时，网站就可通过 Cookie 识别您的浏览器。Cookie 可能会存储用户偏好及其他信息。您可以将浏览器配置为拒绝所有 Cookie 或在网站发送 Cookie 时显示提示。不过，如果没有 Cookie，某些网站功能或服务可能无法正常工作。具体可参见《瑞为客 Cookie 指引》。 </div>
      <div class='bd'><text>B. Web beacon（网络信标） </text>Web beacon 是装嵌在网站或电邮内的电子图像文件案或其他技术，可用于计算访客数目、记录您是否及何时阅览电邮或网站，或用以使用某些 Cookie。 </div>
      <div class='bd'><text>C. Log files（日志文件） </text>Log files 储存自动收集的若干数据。该等数据包括互联网协议（ IP ）地址、浏览器类型、互联网服务提供商（ ISP ）、引用/退出页面、操作系统、日期/时间戳和点击流数据等。 </div>
      <div class='bd'><text>D. ET Tag（实体标签） </text>ET Tag 是在互联网浏览器与互联网服务器之间背后传送的 HTTP 协议标头，可代替 Cookie，用以追踪个别使用者，使我们可更深入地了解和改善我们的服务。</div>
      <div class='bd'><text> E. JavaScript </text>JavaScript 是一种编程语言，用于制作更具互动性和动态的网页。JavaScript 可以设定 Cookie、阅读 Cookie 及删除 Cookie。</div>
      <div class='bd'><text>7.关联公司： </text>指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被依法认定的方式。</div>
      <div class='bd'><text>8.应用数据缓存：</text> 应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。</div>
      <div class='bd'><text>9. 帐户： </text>只要注册帐号并向我们提供一些个人信息（本政策 3.1 节已经说明），您就可以使用我们的服务。当您访问瑞为客时，系统会利用这些帐号信息对您进行身份验证，以防止未经授权的人员访问您的帐号。</div>
      <div class='bd'><text>10. 匿名化： </text>指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</div>
      <div class='hd'><text>15、联系方式</text></div>
      <div class='bd'>若您在使用【瑞为客】的过程中遇到任何问题，或者当您有其他投诉、建议相关问题时，请与我们的客户服务人员联系，您可以通过下列途径获得满意的答复。</div>
      <div class='bd'>联系地址为福建省厦门市思明区软件园二期望海路37号4楼。如果您对我们的政策及对您个人信息的处理有任何疑问、意见、建议或投诉，请发送邮件至pr@reconova.com，或拨打电话至【0592-5939517】，与我们进行联系。</div>
      <div class='bd'>在一般情况下，我们会在15个工作日内对您的请求予以答复。</div>
      <div class='hd hd2'>厦门瑞为信息技术有限公司</div>
      <div class='hd hd2'>2022年10月08日</div>
  </div>
</template>

<style lang="less" scoped>
.text-container {
  overflow-y: auto;
}
.hd {
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 20px;
  margin: 15px;
  font-weight: bold;
  color: #333;
}
.bd {
  font-size: 12px;
  letter-spacing: 1px;
  line-height: 20px;
  margin: 10px 15px;
  color: #777;
  text-indent: 20px;
  text-align: justify;
}
.bd text {
  font-weight: bold;
}
.hd.hd1 {
  text-align: center;
}
.hd.hd2 {
  text-align: right;
}
.bd.bd1 {
  text-indent: 0px;
}
</style>




